import { gql } from '@apollo/client';

/**
 * Stubbed query for approved use cases from Galileo/CaaS.
 * Replace with live Galileo endpoint when available.
 */
export const ApprovedUseCasesQuery = gql`
  query ApprovedUseCases($filter: AIUseCaseFilter) {
    aiGovernance {
      useCases(filter: $filter) {
        useCaseId
        title
        businessUseCase
        status
        overallIntakeStatus
        requestedBy {
          login
          displayName
        }
      }
    }
  }
`;

/**
 * createAISystem mutation.
 * Input shape follows the tasks.md design: name, team, useCaseId, description.
 */
export const CreateAISystemMutation = gql`
  mutation CreateAISystem($input: CreateAISystemInput!) {
    resources {
      application {
        createAISystem(input: $input) {
          success
          message
          application {
            applicationId
            name
            systemType
            aiUseCaseIds
          }
        }
      }
    }
  }
`;

// CreateAISystemInput fields: name, description, useCaseId, owner (login)

/** Mutation to link an AI use case to an application. */
export const AddUseCaseToApplicationMutation = gql`
  mutation AddUseCaseToApplication($input: AddUseCaseInput!) {
    resources {
      application {
        addUseCaseToApplication(input: $input) {
          success
          message
        }
      }
    }
  }
`;

/** Mutation to unlink an AI use case from an application. */
export const RemoveUseCaseFromApplicationMutation = gql`
  mutation RemoveUseCaseFromApplication($input: RemoveUseCaseInput!) {
    resources {
      application {
        removeUseCaseFromApplication(input: $input) {
          success
          message
        }
      }
    }
  }
`;

/**
 * Fetches all AI resources for a given application from the Galileo supergraph.
 * Requires Flow (aiAgents, genAiModels, mcpServers) and Snow (aiUseCases)
 * subgraphs to be live in fusionrage before this query will return real data.
 * Until then, USE_STUBBED_AI_RESOURCES guards a bypass in useAiResources.ts.
 */
export const AiResourcesForApplicationQuery = gql`
  query AiResourcesForApplication($applicationId: Int!) {
    resources {
      application(applicationId: $applicationId) {
        applicationId
        name
        systemType
        aiUseCaseIds
        aiUseCases {
          useCaseId
          useCaseSysId
          title
          status
          overallIntakeStatus
          riskAssessmentScore
          businessUseCase
          priority
          createdAt
          lastUpdatedDate
          vpDecision
          modelName
          platformName
          targetEnvironment
          intendedUsers
          requestedBy {
            login
            displayName
          }
        }
        aiAgents {
          agentId
          name
          authMethod
          createDate
          lastUpdatedDate
          vendorTpeId
          agentType
          deploymentStatus
          levelOfAgency
          lastLoaUpdateDate
          interactionSurface
          logEnabled
          monitoringEnabled
          bryterIntakeId
        }
        genAiModels {
          modelId
          name
          provider
          family
          aiCapabilityType
          createDate
          lastUpdatedDate
          vendorTpeId
          openSource
          cloudOrOnPrem
          deploymentStatus
          transparency
        }
        mcpServers {
          serverId
          name
          description
          createDate
          lastUpdatedDate
          license
          dataClassification
          authMethod
          remoteUrl
        }
      }
    }
  }
`;
